<script>
  /**
   * Sets a preset badge color or a custom color defined with --custom-color.
   * @type {"green" | "yellow" | "red" | "black" | "grey" | "light-grey" | "light-red" | string}
   */
  export let color = "green";

  /**
   * Text displayed inside the badge.
   * @type {string}
   */
  export let text = "";

  /**
   * Displays the badge text in a smaller size.
   * @type {boolean}
   */
  export let small = false;

  /**
   * Displays the badge text in bold.
   * @type {boolean}
   */
  export let bold = false;

  /**
   * Adds a border around the badge.
   * @type {boolean}
   */
  export let border = false;

  /**
   * Overrides the badge text color.
   * @type {string}
   */
  export let textColor = "";

  /**
   * Renders the badge as a button with a close icon before the text and enables click handling.
   * @type {boolean}
   */
  export let clickable = false;

  /**
   * Called when an enabled clickable badge is activated.
   * @type {() => void}
   */
  export let handleClick = () => {};

  /**
   * Applies the disabled appearance and prevents activation when clickable.
   * @type {boolean}
   */
  export let disable = false;

  import Close from "../icons/Close.svelte";
</script>

{#if clickable}
  <button
    type="button"
    disabled="{disable}"
    class:bx--badge="{true}"
    class:bx--badge--color="{true}"
    class:bx--badge--clickable="{clickable}"
    class:bx--badge--disable="{disable}"
    class:bx--badge--border="{border}"
    class:bx--badge--green="{color === 'green'}"
    class:bx--badge--yellow="{color === 'yellow'}"
    class:bx--badge--red="{color === 'red'}"
    class:bx--badge--black="{color === 'black'}"
    class:bx--badge--grey="{color === 'grey'}"
    class:bx--badge--light-grey="{color === 'light-grey'}"
    class:bx--badge--light-red="{color === 'light-red'}"
    class:bx--badge--custom="{color !== 'green' &&
      color !== 'yellow' &&
      color !== 'red' &&
      color !== 'black' &&
      color !== 'grey' &&
      color !== 'light-grey' &&
      color !== 'light-red'}"
    on:click="{() => {
      if (!disable) {
        handleClick();
      }
    }}"
  >
    <span class:small="{small}" class:bold="{bold}" style="color: {textColor}"
      ><Close /> {text}
    </span>
    
  </button>
{:else}
  <div
    class:bx--badge="{true}"
    class:bx--badge--color="{true}"
    class:bx--badge--disable="{disable}"
    class:bx--badge--border="{border}"
    class:bx--badge--green="{color === 'green'}"
    class:bx--badge--yellow="{color === 'yellow'}"
    class:bx--badge--red="{color === 'red'}"
    class:bx--badge--black="{color === 'black'}"
    class:bx--badge--grey="{color === 'grey'}"
    class:bx--badge--light-grey="{color === 'light-grey'}"
    class:bx--badge--light-red="{color === 'light-red'}"
    class:bx--badge--custom="{color !== 'green' &&
      color !== 'yellow' &&
      color !== 'red' &&
      color !== 'black' &&
      color !== 'grey' &&
      color !== 'light-grey' &&
      color !== 'light-red'}"
  >
    <span class:small="{small}" class:bold="{bold}" style="color: {textColor}"
      >{text}</span
    >
  </div>
{/if}
